import type { TendenciaMes } from '@/types/types';
import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

function TrendChart({ data, dataKey, title, color }: { data: TendenciaMes[]; dataKey: keyof TendenciaMes; title: string; color: string }) {
  return (
    <div className="admin-card">
      <div className="admin-card-header pb-1">
        <div className="text-[12px] font-semibold text-(--admin-text)">{title}</div>
      </div>
      <div className="h-45 w-full mt-2">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={data} margin={{ top: 5, right: 10, left: -20, bottom: 0 }}>
            <defs>
              <linearGradient id={`color${dataKey}`} x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor={color} stopOpacity={0.15} />
                <stop offset="95%" stopColor={color} stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="var(--admin-surface2)" />
            <XAxis dataKey="label" axisLine={false} tickLine={false} tick={{ fontSize: 10, fill: 'var(--admin-text3)' }} dy={10} />
            <YAxis
              axisLine={false}
              tickLine={false}
              tick={{ fontSize: 10, fill: 'var(--admin-text3)' }}
              domain={[0, 100]}
              ticks={[0, 50, 100]}
            />
            <Tooltip
              contentStyle={{
                backgroundColor: 'var(--admin-surface)',
                borderColor: 'var(--admin-surface2)',
                fontSize: '11px',
                borderRadius: '8px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
              }}
              formatter={(val: number | undefined) => [`${(val ?? 0).toFixed(1)}%`, 'Cumplimiento'] as [string, string]}
            />
            <Area
              type="monotone"
              dataKey={dataKey}
              stroke={color}
              strokeWidth={2}
              fillOpacity={1}
              fill={`url(#color${dataKey})`}
              animationDuration={1500}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

export function ComplianceTrendCharts({ tendencia }: { tendencia: TendenciaMes[] }) {
  if (!tendencia || tendencia.length === 0) {
    return (
      <div className="admin-card p-12 text-center text-(--admin-text3) text-[13px]">
        No hay datos históricos suficientes para mostrar tendencias por Norma.
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mt-6">
      <TrendChart data={tendencia} dataKey="cumplimientoN1" title="Tendencia Norma 1" color="var(--admin-blue)" />
      <TrendChart data={tendencia} dataKey="cumplimientoN2" title="Tendencia Norma 2" color="var(--admin-purple)" />
      <TrendChart data={tendencia} dataKey="cumplimientoN3" title="Tendencia Norma 3" color="var(--admin-green)" />
    </div>
  );
}
